import React from 'react';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { CheckCircle, Clock, XCircle, AlertCircle } from 'lucide-react';

const statusConfig = {
  // Document statuses
  uploaded: {
    label: 'Uploaded',
    icon: CheckCircle,
    className: 'badge-uploaded border-success/30 bg-success/10 text-success'
  },
  pending: {
    label: 'Pending Review',
    icon: Clock,
    className: 'badge-pending border-warning/30 bg-warning/10 text-warning'
  },
  rejected: {
    label: 'Rejected',
    icon: XCircle,
    className: 'badge-rejected border-destructive/30 bg-destructive/10 text-destructive'
  },
  missing: {
    label: 'Missing',
    icon: AlertCircle,
    className: 'badge-missing border-muted-foreground/30 bg-muted/50 text-muted-foreground'
  },
  reviewing: {
    label: 'Reviewing',
    icon: Clock,
    className: 'badge-pending border-info/30 bg-info/10 text-info'
  },
  completed: {
    label: 'Completed',
    icon: CheckCircle,
    className: 'badge-uploaded border-success/30 bg-success/10 text-success'
  },
  
  // LLC/Tax Filing statuses
  draft: {
    label: 'Draft',
    icon: AlertCircle,
    className: 'badge-draft border-muted-foreground/30 bg-muted/50 text-muted-foreground'
  },
  submitted: {
    label: 'Submitted',
    icon: CheckCircle,
    className: 'badge-submitted border-primary/30 bg-primary/10 text-primary'
  },
  in_review: {
    label: 'In Review',
    icon: Clock,
    className: 'badge-pending border-warning/30 bg-warning/10 text-warning'
  },
  approved: {
    label: 'Approved',
    icon: CheckCircle,
    className: 'badge-approved border-success/30 bg-success/10 text-success'
  }
};

export const DocumentStatusBadge = ({ status, showIcon = true, className }) => {
  const config = statusConfig[status] || {
    label: status?.charAt(0).toUpperCase() + status?.slice(1) || 'Unknown',
    icon: AlertCircle,
    className: 'badge-default border-muted-foreground/30 bg-muted/50 text-muted-foreground'
  };
  const Icon = config.icon;

  return (
    <Badge className={cn('gap-1', config.className, className)}>
      {showIcon && <Icon className="h-3 w-3" />}
      {config.label}
    </Badge>
  );
};
